import { m } from "framer-motion";

import BasicLayout from "../layouts/basic";
import ProjectCard, { Project } from "../components/projects/ProjectCard";

const projects: Project[] = [
  {
    id: 1,
    title: "DevHire",
    description:
      "A full-stack job board for developers with PostgreSQL full-text search, role-based auth, resume uploads to S3, and employer dashboards. Built with Next.js 16, Prisma, and Tailwind CSS.",
    techStack: [
      "Next.js",
      "TypeScript",
      "PostgreSQL",
      "Prisma",
      "NextAuth.js",
      "AWS S3",
      "Tailwind CSS",
    ],
    url: "https://devhire-omega.vercel.app",
    github: "https://github.com/jdonesky/devhire",
  },
];

const Projects = () => {
  return (
    <BasicLayout>
      <div className="px-8 py-16 max-w-5xl mx-auto">
        <m.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-4xl sm:text-5xl font-bold font-title text-left mb-3"
        >
          Projects
        </m.h1>
        <m.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="text-left text-gray-600 mb-10 text-lg"
        >
          Things I&apos;ve built.
        </m.p>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
          }}
          className="gap-6"
        >
          {projects.map((proj) => (
            <ProjectCard key={proj.id} {...proj} />
          ))}
        </div>
      </div>
    </BasicLayout>
  );
};

export default Projects;
